import qs from 'qs';

import api from '../api';
import { s3Upload } from '../s3';

const routes = require("routes.js.erb");

// this should commit to store and update the item, but we're not at that point yet, still work to do so viewer is 100% async.

const updateItem = async function({ commit }, params) {
  const { itemId, body } = params;
  return api
    .patch(routes.api_v5_item_path(itemId), body)
    .then(function(response) {
      const item = formatItemResponse(response);
      commit("setItem", item);
    });
};

// favorite item action relays in 'favorite!' method from Item model. It creates or deletes an entry in favorite_items table.
// for this reason we use a PUT http request and split this action from updateItem
const favoriteItem = async function({ commit }, itemId) {
  return api.put(routes.favorite_api_v5_item_path(itemId))
};

/*
 * the response is structured like
 * response: {
 *   data: {
 *     data: {
 *       item ...
 *     }
 *     included: [reactions]
 *   }
 * }
 */
const getItem = async function({ commit }, itemId) {
  return api.get(routes.api_v5_item_show_viewer_path(itemId)).then(function(response) {
    const item = formatItemResponse(response);
    commit("setItem", item);
    return item;
  });
};

const destroyItem = function({commit}, itemId){
  return api.delete(routes.api_v5_item_path(itemId))
}

const annotate = function({ commit, state }, { itemId, dataUrl }) {
  const uploadUrl = routes.api_v5_item_path(itemId);

  return new Promise(function(resolve, reject) {
    state.annotateionIsSaving = true;
    state.annotationUploadProgress = 0;

    api
      .put(uploadUrl, { overwrite: true })
      .then(function(response) {
        const item = response.data.data.item.attributes;
        const onProgress = (progress) => state.annotationUploadProgress = progress;

        s3Upload(item, dataUrl, onProgress)
          .then(function(response) {
            const doc = $(response.data);
            const key = doc.find("Key").text();
            const checksum = doc.find("ETag").text();
            const completedUrl = `${uploadUrl}/completed`;
            api
              .put(completedUrl, { key, checksum, web_annotate: true })
              .then(function(response) {
                commit("setItem", response.data.data.item);

                state.annotateionIsSaving = false;
                resolve();
              })
              .catch((error) => reject(error));
          })
          .catch((error) => reject(error));
      })
      .catch((error) => reject(error));
  });
};

const bulkAddToCollection = function({ commit }, params) {
  const { organizationId, itemIds } = params;
  return api.get(
    routes.bulk_collections_organization_path(organizationId),
    {
      headers: {
        "Accept": "*/*",
        "x-csrf-token": document.querySelector("[name=csrf-token]").content,
        "x-requested-with": "XMLHttpRequest",
      },
      params: {
        item_ids: itemIds,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "brackets" });
      },
    }
  );
};

const bulkDeleteItems = function({ commit }, params) {
  return api.delete(routes.bulk_destroy_api_v5_items_path(), {
    data: params,
  });
};

const bulkFavoriteItems = function({ commit }, params) {
  return api.put(routes.bulk_favorite_api_v5_items_path(), params);
};

const bulkDownloadItems = function({ commit }, params) {
  return api.post(routes.zip_drops_api_v5_items_path(), params);
};

const setItem = function(payload) {
  const item = formatItemResponse(payload);
  commit("setItem", item);
}

export {
  annotate,
  updateItem,
  getItem,
  destroyItem,
  bulkAddToCollection,
  bulkDeleteItems,
  bulkFavoriteItems,
  bulkDownloadItems,
  favoriteItem,
  setItem,
};

// PRIVATE HELPER FUNCTIONS

function formatItemResponse(params) {
  const item = params.data.data.item;
  const reactions = params.data.included;
  if (reactions && reactions.length > 0 && item.relationships.reactions) {
    const itemIncludesReactions = { ...item };
    itemIncludesReactions.relationships.reactions.data = reactions;
    return itemIncludesReactions;
  }
  return item;
}
